import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_PAYMENT_GATEWAYS, GET_PAYMENT_GATEWAYS_SUCCESS, GET_PAYMENT_GATEWAYS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getPaymentGateways({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/payment-gateways`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PAYMENT_GATEWAYS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PAYMENT_GATEWAYS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PAYMENT_GATEWAYS_ERROR, payload: error });
  }
}

export function* watchGetPaymentGateways() {
  yield takeEvery(GET_PAYMENT_GATEWAYS, getPaymentGateways);
}

function* getPaymentGatewaysSaga() {
  yield all([fork(watchGetPaymentGateways)]);
}

export default getPaymentGatewaysSaga;
